import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

const ComoTeAyudamos = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <main className="min-h-screen bg-slate-50 px-4 py-24">
        <section className="mx-auto max-w-4xl">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="mb-6 inline-flex items-center gap-2 text-sm font-bold text-slate-600 transition hover:text-[#0056D2]"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver al inicio
          </button>

          <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
            <p className="text-xs font-black uppercase tracking-wide text-[#F97316]">
              Cómo te ayudamos
            </p>
            <h1 className="mt-3 max-w-3xl text-3xl font-black leading-tight text-slate-950 sm:text-4xl">
              IA para entender mejor cada espacio comercial.
            </h1>
            <p className="mt-4 max-w-3xl text-base leading-7 text-slate-600">
              Creamos agentes de IA que ayudan a emprendedores y negocios a
              entender qué ubicación tiene mayor potencial para su proyecto, y a
              propietarios a presentar de manera inteligente sus espacios
              comerciales.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ComoTeAyudamos;
